import React, { useContext, useEffect, useRef, useState } from "react";
import AuthContext from "../../context/AuthContext";

import "./MainSection.css";

import Button from "../../components/ui/Button";
import Container from "../../components/ui/Container";

import profile from "../../assets/profile.png";
import frontLeaves from "../../assets/leaves.png";
import backLeaves from "../../assets/backLeaves.png";
// import CenterIcon from "../../components/ui/CenterIcon";
// import { Link } from "react-router-dom";

import "./MainSection.css";
import Dna from "../../components/svgs/Dna";

import $ from "jquery";
import {
    easeOutCubic,
    easeOutSine,
    getPartialPercentage,
    getScrollingPercentage,
} from "../../services/scrollingServices";
import ScrollingContext from "../../context/ScrollingContext";

const MainSection = ({ title = false }) => {
    const dnaCanvas = useRef(null);
    const mainSection = useRef(null);
    const mainSectionContainer = useRef(null);
    const header = useRef(null);
    const headerContainer = useRef(null);
    const dnaOverlay = useRef(null);
    const profileImg = useRef(null);
    const mainSectionContent = useRef(null);
    const mainSectionContentContainer = useRef(null);
    const mainSectionContentBottomText = useRef(null);
    const leavesContainer = useRef(null);
    const leavesInnerContainer = useRef(null);

    const [right, setRight] = useState(0);

    const { scrolling } = useContext(ScrollingContext);

    const initDna = () => {
        var canvas = dnaCanvas.current,
            context = canvas.getContext("2d"),
            width = (canvas.width = window.innerWidth),
            height = (canvas.height = window.innerHeight),
            K = 0.008,
            B = 80,
            move = 0;

        context.strokeStyle = "rgb(54, 144, 144)";

        (function drawFrame() {
            window.requestAnimationFrame(drawFrame, canvas);

            context.clearRect(0, 0, width, height);

            for (var i = 0; i <= width + 80; i++) {
                if (i % 20 === (move | 0)) {
                    context.beginPath();

                    context.moveTo(i, Math.cos(i * K) * B + height / 2);
                    context.lineTo(i - 80, -Math.cos((i - 80) * K) * B + height / 2);
                    context.stroke();

                    context.beginPath();
                    context.arc(i, Math.cos(i * K) * B + height / 2, 10, 0, 2 * Math.PI);
                    context.stroke();

                    context.beginPath();
                    context.arc(
                        i - 80,
                        -Math.cos((i - 80) * K) * B + height / 2,
                        10,
                        0,
                        2 * Math.PI
                    );
                    context.stroke();
                }
            }
            if (move === 19) move = 0;
            else move += 1;
        })();
    };

    function animateMainSection() {
        const { percentage } = getScrollingPercentage(
            scrolling,
            0,
            mainSection.current.getBoundingClientRect().height,
            window.innerHeight
        );

        const headerMoving = getPartialPercentage(percentage, 0, 0.5);
        // const transformX =
        //     0 -
        //     1 * (window.innerWidth / 2 - header.current.getBoundingClientRect().width / 2) +
        //     (window.innerWidth - right);
        // // const headerTransformX = 0 * (1 - headerMoving);
        // const headerTransformX = transformX * (1 - headerMoving);
        // console.log(headerTransformX);
        // console.log(header.current.getBoundingClientRect());
        const headerTransformX =
            (header.current.getBoundingClientRect().width - 0.5 * window.innerWidth) *
            (1 - headerMoving);
        // const headerTransformX =
        //     window.innerWidth -
        //     headerContainer.current.getBoundingClientRect().right -
        //     (window.innerWidth - header.current.getBoundingClientRect().width) / 2;

        // const headerTransformX = 0;
        // console.log(window.innerWidth / 2 - header.current.getBoundingClientRect().width / 2);
        // console.log(headerTransformX);
        const headerTransformY = -100 * easeOutCubic(1 - headerMoving);
        if (percentage < 1) {
            dnaOverlay.current.style.opacity = easeOutCubic(headerMoving) * 0.7;
        }
        header.current.style.transform = `translate(${headerTransformX}px,${headerTransformY}px)  scale(${
            1 - 0.3 * (1 - headerMoving)
        })`;
        // header.current.style.transform = `translate(${headerTransformX}px,${0}px)`;
        const profileImageTransformX =
            (-15 -
                45 -
                profileImg.current.getBoundingClientRect().width +
                0.5 * window.innerWidth) *
            (1 - headerMoving);
        profileImg.current.style.transform = `translate(${profileImageTransformX}px, ${
            50 * (1 - headerMoving)
        }px) scale(${1 - 0.3 * (1 - headerMoving)})`;
        const contentPercentage = getPartialPercentage(percentage, 0.4, 1);
        const contentOffsetTop = mainSectionContentContainer.current.getBoundingClientRect().top;
        const contentTranslateY =
            (window.innerHeight -
                (contentOffsetTop +
                    mainSectionContent.current.getBoundingClientRect().height / 2)) *
            (1 - contentPercentage);
        mainSectionContent.current.style.opacity = contentPercentage;
        mainSectionContent.current.style.transform = `translateY(${contentTranslateY}px) scale(${
            1 - 0.2 * (1 - contentPercentage)
        })`;

        const contentTopPercentage = getPartialPercentage(percentage, 0.6, 1);
        const contetTopTranslateY = 50 * (1 - contentTopPercentage);
        mainSectionContentBottomText.current.style.transform = `translateY(${contetTopTranslateY}px) scale(${
            1 - 0.2 * (1 - contentTopPercentage)
        })`;

        const { percentage: leavesPercentage } = getScrollingPercentage(
            scrolling,
            leavesContainer.current.getBoundingClientRect().top + scrolling,
            window.innerHeight / 2 + leavesContainer.current.getBoundingClientRect().height
        );

        leavesInnerContainer.current.style.transform = `translateY(${
            (1 - easeOutSine(leavesPercentage)) * 120
        }px)`;
        leavesContainer.current.querySelector(
            ".leaves:nth-child(1) img"
        ).style.transform = `translateY(${(1 - leavesPercentage) * 100}px)`;
        animateLeaves({ leavesContainer });

        if (percentage === 1) {
            if (!mainSectionContainer.current.classList.contains("stable")) {
                mainSectionContainer.current.classList.add("stable");
            }
            if (!dnaCanvas.current.classList.contains("stable")) {
                dnaCanvas.current.classList.add("stable");
            }
        } else if (percentage < 1) {
            if (mainSectionContainer.current.classList.contains("stable")) {
                mainSectionContainer.current.classList.remove("stable");
            }
            if (dnaCanvas.current.classList.contains("stable")) {
                dnaCanvas.current.classList.remove("stable");
            }
        }
    }
    function animateLeaves(parameter) {
        const { percentage: leavesPercentage } = getScrollingPercentage(
            scrolling,
            leavesContainer.current.getBoundingClientRect().top + scrolling,
            window.innerHeight / 2 + leavesContainer.current.getBoundingClientRect().height
        );

        leavesInnerContainer.current.style.transform = `translateY(${
            (1 - easeOutSine(leavesPercentage)) * 120
        }px)`;
        leavesContainer.current.querySelector(
            ".leaves:nth-child(1) img"
        ).style.transform = `translateY(${(1 - leavesPercentage) * 100}px)`;
        // console.log(leavesContainer.current.querySelector(".leaves:nth-child(1) img"));
    }

    useEffect(() => {
        initDna();
        if (window.innerWidth > 768) {
            setRight(header.current.getBoundingClientRect().right);
            animateMainSection();
        } else {
        }
    }, []);

    useEffect(() => {
        // animateDna();
        if (window.innerWidth > 768) {
            animateMainSection();
        } else {
            animateLeaves();
        }
    }, [scrolling]);

    return (
        <>
            <section className="main-section negative-nav-margin" ref={mainSection}>
                <canvas
                    className="dnaCanvas w-full overflow-hidden"
                    id="canvas"
                    ref={dnaCanvas}
                ></canvas>
                <div className="dna-overlay w-full h-full smooth" ref={dnaOverlay}></div>
                <div className="opacity-30 sm:block hidden">
                    <div className="absolute right-10 top-1/4 w-2 h-20 bg-cyan-500 rounded-full"></div>
                    <div className="absolute right-20 top-1/3 w-1 h-32 bg-cyan-500 rounded-full"></div>
                    <div className="absolute left-20 top-1/2 w-1 h-36 bg-cyan-400 rounded-full"></div>
                    <div className="absolute left-40 top-1/4 w-1 h-36 bg-cyan-400 rounded-full"></div>

                    <div className="absolute right-32 top-1/2 w-1 h-32 bg-cyan-500 rounded-full"></div>
                    <div className="absolute left-10 top-1/3 w-2 h-10 bg-cyan-400 rounded-full"></div>
                    <div className="absolute left-32 top-2/3 w-1 h-36 bg-cyan-400 rounded-full"></div>
                </div>
                <div
                    className="w-full md:h-screen md:fixed relative z-10 main-section__container md:py-0  py-20"
                    ref={mainSectionContainer}
                >
                    <Container className="h-full">
                        <div className="flex h-full flex-col md:flex-row flex-center-both md:space-y-0 space-y-10">
                            <div className="md:basis-7/12 basis-full text-center flex-center-both">
                                <div
                                    className="main-section__text md:space-y-0 space-y-5"
                                    ref={headerContainer}
                                >
                                    <div
                                        className="main-section__header font-bigmain font-w-bold mt-n4"
                                        id="header-original"
                                        ref={header}
                                    >
                                        <div className="main-section-text__top font-big clr-navy-dark-1 font-w-normal mb-n3">
                                            عائلة
                                        </div>
                                        <div className="space-x-2 space-x-reverse font-cairo">
                                            <span className="text-cyan-500 font-bigmax">د /</span>
                                            <span className="">محمد</span>
                                            <span className="text-cyan-500">أيمن</span>
                                        </div>
                                    </div>
                                    <div className="main-section__divider py-md-5 py-3"></div>

                                    <div
                                        className="content__contianer"
                                        ref={mainSectionContentContainer}
                                    >
                                        <div
                                            className="main-section__content font-big font-w-medium"
                                            ref={mainSectionContent}
                                        >
                                            <div className="top flex space-x-2 space-x-reverse flex-wrap flex-center-both">
                                                <span>لكل ما يتعلق</span>
                                                <span className="text-yellow-500 dark:text-yellow-300 smooth">
                                                    بمنهج الأحياء
                                                </span>
                                            </div>
                                            <div
                                                className="text-cyan-500 bottom"
                                                ref={mainSectionContentBottomText}
                                            >
                                                للثانوية العامة
                                            </div>
                                            {title && (
                                                <div className="font-normal pt-6 text-yellow-500 dark:text-yellow-300 smooth font-w-bold">
                                                    {title}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="md:basis-7/12 basis-full flex-center-both">
                                <div className="w-full max-w-md">
                                    <img
                                        src={profile}
                                        alt="Mohammed Ayman"
                                        className="w-full"
                                        ref={profileImg}
                                    />
                                </div>
                            </div>
                        </div>
                    </Container>
                    <div className="animated__corona">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
                            <circle cx={64} cy={64} r={46.7} fill="#bde5ec" />
                            <circle cx={64} cy={64} r={35} fill="#f7f7eb" />
                            <path
                                fill="#e44450"
                                d="M67.7 3.1c1.4.5 1.9 1 2 1.5 0 .5-.2 1-.8 1.5-.5.5-1.2 1-1.5 1.5-.4.4-.4.9-.5 1.4-.4 2-.7 4-1 5.9-.3 2-.5 4-.6 5.9-.1 2-.2 4 0 5.9.1.7-.5 1.3-1.2 1.4-.7.1-1.3-.5-1.4-1.2v-.2c.1-2 .1-4 0-5.9-.1-2-.3-4-.6-5.9-.3-2-.6-4-1-5.9-.1-.5-.1-1-.5-1.5s-1-1-1.5-1.5-.8-1-.8-1.5c.1-.5.6-1 2-1.5 2.6-.7 5.1-.7 7.4.1zm56.2 64.6c-.5 1.4-1 1.9-1.5 2-.5 0-1-.2-1.5-.8-.5-.5-1-1.2-1.5-1.5-.5-.4-1-.4-1.5-.5-2-.4-4-.7-5.9-1-2-.3-4-.5-5.9-.6-2-.1-4-.2-5.9 0-.7.1-1.3-.5-1.4-1.2-.1-.7.5-1.3 1.2-1.4h.2c2 .1 4 .1 5.9 0 2-.1 4-.3 5.9-.6 2-.3 4-.6 5.9-1 .5-.1 1-.1 1.5-.5s1-1 1.5-1.5 1-.8 1.5-.8c.5.1 1 .6 1.5 2 .8 2.6.8 5.1 0 7.4zm-64.6 56.2c-1.4-.5-1.9-1-2-1.5 0-.5.2-1 .8-1.5.5-.5 1.2-1 1.5-1.5.4-.5.4-1 .5-1.5.4-2 .7-4 1-5.9.3-2 .5-4 .6-5.9.1-2 .2-4 0-5.9-.1-.7.5-1.3 1.2-1.4.7-.1 1.3.5 1.4 1.2v.2c-.1 2-.1 4 0 5.9.1 2 .3 4 .6 5.9.3 2 .6 4 1 5.9.1.5.1 1 .5 1.5s1 1 1.5 1.5.8 1 .8 1.5c-.1.5-.6 1-2 1.5-2.6.8-5.1.8-7.4 0zM3.1 59.3c.5-1.4 1-1.9 1.5-2 .5 0 1 .2 1.5.8.5.5 1 1.2 1.5 1.5.4.4.9.4 1.4.5 2 .4 4 .7 5.9 1 2 .3 4 .5 5.9.6 2 .1 4 .2 5.9 0 .7-.1 1.3.5 1.4 1.2.1.7-.5 1.3-1.2 1.4h-.2c-2-.1-4-.1-5.9 0-2 .1-4 .3-5.9.6-2 .3-4 .6-5.9 1-.5.1-1 .1-1.5.5s-1 1-1.5 1.5-1 .8-1.5.8c-.5-.1-1-.6-1.5-2-.7-2.6-.7-5.1.1-7.4zM36.9 9.1c1.5-.3 2.2-.1 2.5.3.3.4.3 1 .1 1.7-.2.7-.5 1.4-.6 2.1-.1.6.2 1 .3 1.5.7 1.9 1.4 3.8 2.1 5.6.8 1.8 1.6 3.7 2.5 5.4.9 1.8 1.8 3.5 3 5.1.4.6.2 1.4-.3 1.8-.6.4-1.4.2-1.8-.3 0-.1-.1-.1-.1-.2-.9-1.8-1.9-3.5-3-5.1-1.1-1.7-2.2-3.3-3.5-4.8-1.2-1.6-2.5-3.1-3.8-4.7-.3-.4-.6-.8-1.2-1-.6-.2-1.4-.3-2.1-.5-.7-.2-1.2-.5-1.4-.9-.2-.5 0-1.1 1-2.3 1.7-2 4-3.2 6.3-3.7zm81 27.8c.3 1.5.1 2.2-.3 2.5-.4.3-1 .3-1.7.1-.7-.2-1.4-.5-2.1-.6-.6-.1-1 .2-1.5.3-1.9.7-3.8 1.4-5.6 2.1-1.8.8-3.7 1.6-5.4 2.5-1.8.9-3.5 1.8-5.1 3-.6.4-1.4.2-1.8-.3-.4-.6-.2-1.4.3-1.8.1 0 .1-.1.2-.1 1.8-.9 3.5-1.9 5.1-3 1.7-1.1 3.3-2.2 4.8-3.5 1.6-1.2 3.1-2.5 4.7-3.8.4-.3.8-.6 1-1.2.2-.6.3-1.4.5-2.1.2-.7.5-1.2.9-1.4.5-.2 1.1 0 2.3 1 2 1.7 3.2 4 3.7 6.3zm-27.8 81c-1.5.3-2.2.1-2.5-.3-.3-.4-.3-1-.1-1.7.2-.7.5-1.4.6-2.1.1-.6-.2-1-.3-1.5-.7-1.9-1.4-3.8-2.1-5.6-.8-1.8-1.6-3.7-2.5-5.4-.9-1.8-1.8-3.5-3-5.1-.4-.6-.2-1.4.3-1.8s1.4-.2 1.8.3c0 .1.1.1.1.2.9 1.8 1.9 3.5 3 5.1 1.1 1.7 2.2 3.3 3.5 4.8 1.2 1.6 2.5 3.1 3.8 4.7.3.4.6.8 1.2 1 .6.2 1.4.3 2.1.5.7.2 1.2.5 1.4.9.2.5 0 1.1-1 2.3-1.7 2-4 3.2-6.3 3.7zm-81-27.8c-.3-1.5-.1-2.2.3-2.5.4-.3 1-.3 1.7-.1.7.2 1.4.5 2.1.6.6.1 1-.2 1.5-.3 1.9-.7 3.8-1.4 5.6-2.1 1.8-.8 3.7-1.6 5.4-2.5 1.8-.9 3.5-1.8 5.1-3 .6-.4 1.4-.2 1.8.3s.2 1.4-.3 1.8c-.1 0-.1.1-.2.1-1.8.9-3.5 1.9-5.1 3-1.7 1.1-3.3 2.2-4.8 3.5-1.6 1.2-3.1 2.5-4.7 3.8-.4.3-.8.6-1 1.2-.2.6-.3 1.4-.5 2.1-.2.7-.5 1.2-.9 1.4-.5.2-1.1 0-2.3-1-2-1.7-3.2-4-3.7-6.3zm4.2-60.4c1.1-1 1.8-1.2 2.3-1 .5.2.7.7.9 1.4.2.7.3 1.5.5 2.1.2.6.7.8 1 1.2 1.5 1.3 3.1 2.6 4.7 3.8 1.6 1.2 3.2 2.4 4.8 3.5 1.7 1.1 3.3 2.1 5.1 3 .6.3.9 1.1.6 1.7-.3.6-1.1.9-1.7.6-.1 0-.1-.1-.2-.1-1.6-1.1-3.4-2.1-5.1-3-1.8-.9-3.6-1.7-5.4-2.5-1.8-.8-3.7-1.5-5.6-2.1-.5-.2-.9-.4-1.5-.3-.6.1-1.4.4-2.1.6-.7.2-1.3.2-1.7-.1-.4-.3-.6-1-.3-2.5.6-2.6 1.9-4.8 3.7-6.3zm84-16.4c1 1.1 1.2 1.8 1 2.3-.2.5-.7.7-1.4.9-.7.2-1.5.3-2.1.5-.6.2-.8.7-1.2 1-1.3 1.5-2.6 3.1-3.8 4.7-1.2 1.6-2.4 3.2-3.5 4.8-1.1 1.7-2.1 3.3-3 5.1-.3.6-1.1.9-1.7.6-.6-.3-.9-1.1-.6-1.7 0-.1.1-.1.1-.2 1.1-1.6 2.1-3.4 3-5.1.9-1.8 1.7-3.6 2.5-5.4.8-1.8 1.5-3.7 2.1-5.6.2-.5.4-.9.3-1.5-.1-.6-.4-1.4-.6-2.1-.2-.7-.2-1.3.1-1.7.3-.4 1-.6 2.5-.3 2.6.6 4.8 1.9 6.3 3.7zm16.4 84c-1.1 1-1.8 1.2-2.3 1-.5-.2-.7-.7-.9-1.4-.2-.7-.3-1.5-.5-2.1-.2-.6-.7-.8-1-1.2-1.5-1.3-3.1-2.6-4.7-3.8-1.6-1.2-3.2-2.4-4.8-3.5-1.7-1.1-3.3-2.1-5.1-3-.6-.3-.9-1.1-.6-1.7s1.1-.9 1.7-.6c.1 0 .1.1.2.1 1.6 1.1 3.4 2.1 5.1 3 1.8.9 3.6 1.7 5.4 2.5 1.8.8 3.7 1.5 5.6 2.1.5.2.9.4 1.5.3.6-.1 1.4-.4 2.1-.6.7-.2 1.3-.2 1.7.1.4.3.6 1 .3 2.5-.6 2.6-1.9 4.8-3.7 6.3zm-84 16.4c-1-1.1-1.2-1.8-1-2.3.2-.5.7-.7 1.4-.9.7-.2 1.5-.3 2.1-.5.6-.2.8-.7 1.2-1 1.3-1.5 2.6-3.1 3.8-4.7 1.2-1.6 2.4-3.2 3.5-4.8 1.1-1.7 2.1-3.3 3-5.1.3-.6 1.1-.9 1.7-.6s.9 1.1.6 1.7c0 .1-.1.1-.1.2-1.1 1.6-2.1 3.4-3 5.1-.9 1.8-1.7 3.6-2.5 5.4-.8 1.8-1.5 3.7-2.1 5.6-.2.5-.4.9-.3 1.5.1.6.4 1.4.6 2.1.2.7.2 1.3-.1 1.7-.3.4-1 .6-2.5.3-2.6-.6-4.8-1.9-6.3-3.7z"
                            />
                            <path
                                fill="#2652e4"
                                d="M71.8 28.5c.5-.9.9-1.9 1.2-2.8.3-1 .5-1.9.7-2.9.1-1 .1-2.1 0-3.1 0-.5 0-1 .1-1.5s0-1 .9-1.3c1.2-.3 2.5 0 3.3.9.7.7.3 1.1.2 1.6-.2.5-.4.9-.7 1.4-.5.9-1.1 1.8-1.5 2.7-.4.9-.6 1.9-.9 2.9-.2 1-.4 2-.3 3 0 .9-.7 1.6-1.6 1.6s-1.6-.7-1.6-1.6c-.1-.3 0-.6.2-.9zM55.3 99.3c-.6.9-.9 1.8-1.3 2.8-.3 1-.6 1.9-.8 2.9-.2 1-.1 2.1-.1 3.1 0 .5 0 1-.1 1.5s0 1-1 1.3c-1.2.3-2.5-.1-3.3-1-.7-.7-.3-1.1-.1-1.6.2-.5.5-.9.7-1.4.6-.9 1.2-1.8 1.6-2.7.4-.9.7-1.9.9-2.9.2-1 .4-2 .4-3 0-.9.7-1.6 1.6-1.6.9 0 1.6.7 1.6 1.6.1.5 0 .8-.1 1zm43.4-27.1c.9.5 1.9.9 2.8 1.2 1 .3 1.9.5 2.9.7 1 .1 2.1.1 3.1 0 .5 0 1 0 1.5.1s1 0 1.3.9c.3 1.2 0 2.5-.9 3.3-.7.7-1.1.3-1.6.2-.5-.2-.9-.4-1.4-.7-.9-.5-1.8-1.1-2.7-1.5-.9-.4-1.9-.6-2.9-.9-1-.2-2-.4-3-.3-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6.4 0 .7.1.9.2zM28 55.8c-.9-.6-1.8-.9-2.8-1.3-1-.3-1.9-.6-2.9-.8-1-.2-2.1-.1-3.1-.1-.5 0-1 0-1.5-.1s-1 0-1.3-1c-.3-1.2.1-2.5 1-3.3.7-.7 1.1-.3 1.6-.1.5.2.9.5 1.4.7.9.6 1.8 1.2 2.7 1.6.9.4 1.9.7 2.9.9 1 .2 2 .4 3 .4.9 0 1.6.7 1.6 1.6s-.9 1.7-1.8 1.7c-.3 0-.6-.1-.8-.2zm70.2-2.4c1 0 2-.2 3-.4s1.9-.5 2.9-.9c.9-.4 1.8-1 2.7-1.5.4-.3.9-.5 1.4-.7.5-.2.9-.5 1.6.2.9.9 1.2 2.2.9 3.3-.3 1-.8.9-1.3 1-.5.1-1 .1-1.5.1-1 0-2.1-.1-3.1.1s-2 .4-2.9.7c-1 .3-1.9.7-2.8 1.2-.8.5-1.7.2-2.2-.5-.5-.8-.2-1.7.5-2.2.2-.3.5-.4.8-.4zM28.7 74.6c-1 0-2.1.1-3 .3-1 .2-2 .5-2.9.8-1 .3-1.8.9-2.8 1.4-.5.3-.9.5-1.4.7-.5.2-.9.5-1.6-.2-.9-.9-1.1-2.2-.8-3.3.3-1 .8-.8 1.3-.9.5-.1 1-.1 1.5 0 1 0 2.1.1 3.1 0s2-.3 3-.6 1.9-.6 2.8-1.1c.8-.4 1.7-.2 2.2.6.4.8.2 1.7-.6 2.2-.3 0-.6.1-.8.1zm45.1 24c0 1 .2 2 .4 3s.5 1.9.9 2.9c.4.9 1 1.8 1.5 2.7.3.4.5.9.7 1.4.2.5.5.9-.2 1.6-.9.9-2.2 1.2-3.3.9-1-.3-.9-.8-1-1.3-.1-.5-.1-1-.1-1.5 0-1 .1-2.1-.1-3.1s-.4-2-.7-2.9c-.3-1-.7-1.9-1.2-2.8-.5-.8-.2-1.7.5-2.2s1.7-.2 2.2.5c.4.3.4.5.4.8zM52.7 29.1c0-1-.1-2.1-.3-3-.2-1-.5-2-.8-2.9-.3-1-.9-1.8-1.4-2.8-.3-.5-.5-.9-.7-1.4-.2-.5-.5-.9.2-1.6.9-.9 2.2-1.1 3.3-.8 1 .3.8.8.9 1.3.1.5.1 1 0 1.5 0 1-.1 2.1 0 3.1s.3 2 .6 3 .6 1.9 1.1 2.8c.4.8.2 1.7-.6 2.2-.8.4-1.7.2-2.2-.6-.1-.2-.1-.5-.1-.8zm35.6 8.3c.9-.5 1.7-1.2 2.4-1.8.7-.7 1.4-1.4 2.1-2.2.6-.8 1.1-1.8 1.6-2.7.3-.5.5-.9.8-1.3.3-.4.5-.9 1.5-.7 1.2.3 2.1 1.3 2.4 2.4.3 1-.3 1.2-.7 1.5-.4.3-.8.6-1.3.8-.9.5-1.9 1-2.7 1.6-.8.6-1.5 1.3-2.2 2.1-.7.8-1.3 1.5-1.8 2.5-.4.8-1.4 1-2.2.6-.8-.4-1-1.4-.6-2.2.2-.2.5-.4.7-.6zM38.7 90.5c-.9.5-1.7 1.1-2.5 1.8s-1.5 1.4-2.1 2.2c-.7.8-1.1 1.7-1.7 2.6-.3.4-.5.9-.9 1.3-.3.3-.5.8-1.5.6-1.2-.3-2.1-1.3-2.4-2.5-.2-1 .3-1.1.7-1.5.4-.3.9-.6 1.3-.8.9-.5 1.9-.9 2.7-1.5.8-.6 1.5-1.3 2.3-2 .7-.7 1.4-1.5 1.9-2.4.4-.8 1.4-1 2.2-.6.8.4 1 1.4.6 2.2-.2.3-.4.5-.6.6zm51.1-1.7c.5.9 1.2 1.7 1.8 2.4.7.7 1.4 1.4 2.2 2.1.8.6 1.8 1.1 2.7 1.6.5.3.9.5 1.3.8.4.3.9.5.7 1.5-.3 1.2-1.3 2.1-2.4 2.4-1 .3-1.2-.3-1.5-.7-.3-.4-.6-.8-.8-1.3-.5-.9-1-1.9-1.6-2.7-.6-.8-1.3-1.5-2.1-2.2-.8-.7-1.5-1.3-2.5-1.8-.8-.4-1-1.4-.6-2.2.4-.8 1.4-1 2.2-.6.3.2.5.4.6.7zm-53-49.7c-.5-.9-1.1-1.7-1.8-2.5s-1.4-1.5-2.2-2.1c-.8-.7-1.7-1.1-2.6-1.7-.4-.3-.9-.5-1.3-.9-.4-.3-.9-.5-.6-1.5.3-1.2 1.3-2.1 2.5-2.4 1-.2 1.1.3 1.5.7.3.4.6.9.8 1.3.5.9.9 1.9 1.5 2.7.6.8 1.3 1.5 2 2.3.7.7 1.5 1.4 2.4 1.9.8.4 1 1.4.6 2.2-.4.8-1.4 1-2.2.6-.3-.1-.5-.3-.6-.6z"
                            />
                            <path
                                fill="none"
                                stroke="#ecc6c3"
                                strokeLinecap="round"
                                strokeMiterlimit={10}
                                strokeWidth={4}
                                d="M65.7 91.8c1.2-2.8 2-5.8 2.5-8.7.4-3 .4-5.8 0-8.7-.1-.7 0-1.1.2-1.2.2-.1.6.1 1.1.7 1.4 1.8 3.1 3.4 4.9 4.9 1.8 1.5 3.9 2.7 6.1 3.8 1.4.7 2.8-.5 2.1-2-.9-2.3-2.1-4.4-3.4-6.3-.7-1-1.4-1.9-2.1-2.8-.8-.9-1.6-1.7-2.4-2.5-1-1-.8-1.5.6-1.2 2.3.5 4.5.7 6.9.7 2.3-.1 4.8-.3 7.1-.9 1.5-.4 1.8-2.2.4-2.9-2.2-1.2-4.4-2-6.7-2.7-1.1-.3-2.3-.6-3.4-.8-1.2-.2-2.3-.3-3.5-.4-1.4-.1-1.6-.7-.3-1.4 2.1-1.1 3.9-2.4 5.8-3.9 1.8-1.5 3.4-3.3 4.9-5.3.9-1.2 0-2.8-1.6-2.5-2.4.5-4.7 1.2-6.9 2.2-2.1.9-4.2 2.1-6 3.5-1.2.8-1.7.5-1.1-.9.9-2.1 1.5-4.3 1.9-6.7.4-2.3.6-4.8.4-7.2 0-.8-.5-1.3-1-1.5-.6-.2-1.2 0-1.7.6-.8 1-1.5 1.9-2.1 2.9-.7 1-1.2 2.1-1.8 3.1-1 2.1-1.8 4.3-2.4 6.5-.4 1.4-1 1.5-1.4 0-.7-2.2-1.6-4.3-2.8-6.4-1.2-2-2.6-4-4.2-5.8-1-1.2-2.8-.6-2.7 1.1 0 1.2.1 2.4.2 3.6.1 1.2.4 2.4.6 3.5.5 2.3 1.3 4.5 2.3 6.5.6 1.3.2 1.8-1.1.9-1.9-1.2-4-2.3-6.2-3.1-2.2-.8-4.6-1.5-7-1.8-.8-.1-1.4.2-1.7.7-.3.5-.2 1.2.3 1.8 3.1 3.7 7 6.6 11.2 8.5 1.3.6 1.3 1.2-.2 1.4-2.2.3-4.5.8-6.8 1.5-2.2.8-4.4 1.8-6.5 3.1-.7.4-.9 1.1-.8 1.6.1.6.6 1.1 1.4 1.2 4.8.9 9.6.6 14.1-.6.7-.2 1.2-.2 1.3.1.1.2 0 .6-.6 1.1-4 4.1-6.9 9.4-8.3 15.5"
                            />
                        </svg>
                    </div>
                    <div className="animated__bones">
                        <style>
                            {`.animated__bones {
                    --svg-shadow-color: #a7a8ad;
                    --svg-bone-color: #dfe4e6;
                }

                .darkmode .animated__bones {
                    --svg-shadow-color: #d5d6db;
                    --svg-bone-color: #ebf0f3;
                }

                .bone {
                    fill: var(--svg-bone-color)
                }

                .shadow {
                    fill: var(--svg-shadow-color)
                }`}
                        </style>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            data-name="Layer 1"
                            viewBox="0 0 125 125"
                        >
                            <g className="bottom__bone">
                                <path
                                    className="smooth bone bone-bottom-left"
                                    d="M48.261 69.844s-7.069-2.638-5.064 5.064 3.587 2.321 4.326 9.496.738 27.12.738 27.12h5.065s.422-33.662-1.055-39.043-4.01-2.637-4.01-2.637Z"
                                />
                                <path
                                    className="smooth shadow shadow-bottom"
                                    d="M58.514 111.133s.715-31.144-1.429-34.003-6.273-3.89-8.735-6.193-1.985-6.526-1.43-8.266 6.195 3.263 10.483 2.31 3.811-1.509 6.432-1.826 3.335 1.429 7.861 1.747 7.366-3.456 9.56-2.601.048 7.682-2.651 10.144c-8.378 7.642-6.274 29.159-6.512 38.688Z"
                                />
                                <path
                                    className="smooth bone bone-bottom-right"
                                    d="M59.304 111.133s.617-30.421-1.235-32.97-5.42-3.47-7.547-5.523-1.715-5.818-1.235-7.37 5.352 2.91 9.056 2.06 3.293-1.345 5.557-1.628 2.882 1.274 6.792 1.557 6.364-3.08 8.259-2.319.042 6.85-2.29 9.045c-7.238 6.814-5.42 28.652-5.626 37.148Z"
                                />
                            </g>
                            <g className="top__bone">
                                <path
                                    className="smooth shadow shadow-top"
                                    d="M71.26 13.475s.24 16.492 1.444 22.15 4.213 5.777 6.62 10.833 3.25 9.51.963 13-9.389 3.25-12.157.602-6.373-.963-7.46.241-6.384 5.658-13.125-.24 1.79-14.187 3.13-16.612c3.74-6.765 4.308-22.027 3.852-29.974Z"
                                />
                                <path
                                    className="smooth bone bone-top"
                                    d="M70.436 13.475s.216 17.35 1.295 22.422 3.777 5.18 5.936 9.713 2.913 8.525.863 11.655-8.418 2.913-10.9.54-5.713-.864-6.687.215-5.723 5.072-11.767-.216 1.604-12.718 2.806-14.892c3.353-6.065 3.862-22.313 3.454-29.437Z"
                                />
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="animated__line smooth"></div>

                <div className="leaves__container w-full overflow-hidden" ref={leavesContainer}>
                    <div className="leaves__inner-container" ref={leavesInnerContainer}>
                        <div className="leaves leaves-back">
                            <img src={backLeaves} alt="decoration" />
                        </div>
                        <div className="leaves leaves-front">
                            <img src={frontLeaves} alt="decoration" />
                        </div>
                        <div className="leaves leavesPlaceHolder">
                            <img src={backLeaves} alt="decoration" />
                        </div>
                    </div>
                    <div className="leaves-overlay absolute h-full w-full inset-0"></div>
                </div>
            </section>
        </>
    );
};

export default MainSection;
